import { buildClient } from '../utils/url';
var logService = {
    baseUrl: {
        SERVICE: 'log',
        CALCULATION_METHODS: 'calculation-methods',
        ACTIVITY_DATA_SOURCES: 'activity-data-sources',
        FACTOR_REQUESTS: 'factor-requests',
        CATEGORIES: 'categories',
        FACTORS: 'factors',
        IMPORT_TEMPLATES: 'import-templates',
        LOGS: 'logs',
        LOG_ENTRIES: 'log-entries',
        PRODUCT_LOG_ENTRIES: 'product-log-entries',
        QUANTITIES: 'quantities',
        SCOPES: 'scopes',
        CLOSED_PERIODS: 'closed-periods',
        EMISSION_FACTOR_CHANGELOGS: 'emission-factor-changelogs',
        SUBCATEGORIES: 'subcategories',
        TAGS: 'tags',
        PRODUCT_TAGS: 'product-tags',
        QUANTITY_TAGS: 'quantity-tags',
        TERRITORIES: 'territories',
        UNITS: 'units',
        BULK_IMPORT: 'bulk-import',
        USER_OPTIONS: 'user-options',
        MODELED_IMPACTS: 'modeled-impacts',
        LIFECYCLE_STEPS: 'lifecycle_steps',
    },
    activity_data_sources: {
        GET_MANY: '/',
        GET_MANY_WITHOUT_STRUCTURE: '/without-structure',
        ADS_PATH_STRUCTURE: '/ads-path-structure/:id',
        SEARCH: '/',
        GET_CLIMATIQ: '/climatiq',
        UPDATE: '/:id',
        UPDATE_MANY: '/many',
        CREATE_SCOPED: '/scoped',
    },
    lifecycle_steps: {
        GET_MANY: '/',
    },
    modeledImpacts: {
        GET_MANY: '/',
        SEARCH: '/',
    },
    calculation_methods: {
        GET_MANY: '/',
    },
    categories: {
        GET_MANY: '/',
        GET_ONE: '/:id',
        GET_FOR_LOG_CREATION: '/log-creation',
        GET_MANY_WITH_LOGS: '/with-logs',
        GET_MODELED_IMPACT_CATEGORIES: '/modeled-impact-categories',
    },
    factors: {
        GET_MANY: '/',
        SEARCH: '/search',
        GET_ONE: '/:id',
        CREATE: '/create',
        UPDATE_ONE: '/:id',
        DELETE_ONE: '/:id',
        USED: '/used',
        ACTIVITY_DATA_SOURCE: '/activity-data-source',
        DATA: '/data',
        SUBMIT_CHANGE: '/submit-change',
        ORIGIN: '/origin',
        GET_FILTERS: '/filters',
        ESTIMATE: '/estimate',
    },
    factorRequests: {
        CREATE: '/',
        GET_ONE: '/:id',
        GET_MANY: '/',
        UPDATE_ONE: '/:id',
        DELETE_ONE: '/:id',
    },
    importTemplates: {
        GENERATE_ONE: '/',
        REGENERATE_ACTIVITY_DATA: '/regenerate-activity-data',
    },
    logs: {
        GET_MANY: '/',
        GET_ONE: '/:id',
        CREATE: '/',
        UPDATE_ONE: '/:id',
        DELETE_ONE: '/:id',
        DELETE_MANY: '/',
        UPLOAD_FILES: '/:id/files',
        REMOVE_FILE: '/:id/files',
        COUNT: '/count',
        SEARCH: '/search',
        CALCULATE_CARBON_SUM: '/carbon-sum',
        GET_LOG_CHANGELOGS: '/changelog',
        UPDATE_CALCULATIONS: '/calculations',
        UPDATE_CALCULATIONS_OF_SUBCATEGORY: '/calculations/:subcategoryId',
        SIGNED_PUT_URL: '/signed-put-url',
        GET_BUSINESS_UNIT_OVERVIEW: '/business-unit-overview/:businessUnitId',
        GET_PRODUCT_OVERVIEW: '/product-overview/:businessUnitId',
        GET_RANGE: '/range',
    },
    logEntries: {
        GET_MANY: '/',
        GET_ONE: '/:id',
        CREATE: '/',
        UPDATE_ONE: '/:id',
        DELETE_ONE: '/:id',
        COUNT: '/count',
    },
    productLogEntries: {
        GET_MANY: '/',
        GET_ONE: '/:id',
        CREATE: '/',
        CREATE_MANY: '/many',
        UPDATE_ONE: '/:id',
        DELETE_ONE: '/:id',
        DELETE_MANY: '/many',
    },
    bulkImport: {
        VALIDATE: '/validate',
        PREVIEW: '/preview',
        CREATE_ONE: '/create',
        GET_MANY: '/',
        DELETE_ONE: '/:id',
        CHECK_VALIDATE: '/:id/check-validate',
        SIGNED_PUT_URL: '/signed-put-url',
    },
    quantities: {
        DELETE_FOR_ORGANIZATION: '/organization',
        GET_MANY: '/',
        GET_ONE: '/:id',
        CREATE: '/',
        UPDATE_ONE: '/:id',
        DELETE_ONE: '/:id',
        SEARCH: '/search',
    },
    scopes: {
        GET_MANY: '/',
        GET_ONE: '/:id',
    },
    closedPeriods: {
        GET_MANY: '/',
        CREATE: '/',
        UPDATE: '/:id',
        GET_ONE: '/:id',
        DELETE: '/:id',
        PREVIEW_KEY_STATS: '/preview-key-stats',
        CHECK_CLOSED_PERIOD: '/check-closed-period',
        OUTDATED_EMISSION_FACTORS: '/:id/outdated-emission-factors',
        STATUS: '/:id/status',
    },
    subcategories: {
        GET_MANY: '/',
        GET_ONE: '/:id',
        GET_FOR_LOG_CREATION: '/log-creation',
    },
    productTags: {
        GET_MANY: '/',
        CREATE: '/',
        DELETE_ONE: '/:id',
        GET_ONE: '/:id',
    },
    quantityTags: {
        GET_MANY: '/',
        CREATE: '/',
        DELETE_ONE: '/:id',
        GET_ONE: '/:id',
    },
    tags: {
        GET_MANY: '/',
        CREATE: '/',
        DELETE_ONE: '/:id',
        UPDATE_ONE: '/:id',
        GET_ONE: '/:id',
    },
    units: {
        GET_MANY: '/',
        CREATE: '/',
        SEARCH: '/search',
        GET_ONE: '/:id',
        GET_DENOMINATOR_FROM_EF: '/get-denominator-from-ef',
    },
    userOptions: {
        GET_FOR_LOG_CREATION: '/log-creation',
    },
    territories: {
        GET_MANY: '/',
        SEARCH: '/',
        GET_ONE: '/:id',
    },
    emissionFactorChangelogs: {
        GET_MANY: '/',
        CREATE: '/',
    },
};
var logServiceClient = {
    activity_data_sources: buildClient(logService.baseUrl.ACTIVITY_DATA_SOURCES, logService.activity_data_sources),
    calculation_methods: buildClient(logService.baseUrl.CALCULATION_METHODS, logService.calculation_methods),
    categories: buildClient(logService.baseUrl.CATEGORIES, logService.categories),
    factors: buildClient(logService.baseUrl.FACTORS, logService.factors),
    factorRequests: buildClient(logService.baseUrl.FACTOR_REQUESTS, logService.factorRequests),
    importTemplates: buildClient(logService.baseUrl.IMPORT_TEMPLATES, logService.importTemplates),
    lifecycle_steps: buildClient(logService.baseUrl.LIFECYCLE_STEPS, logService.lifecycle_steps),
    logEntries: buildClient(logService.baseUrl.LOG_ENTRIES, logService.logEntries),
    productLogEntries: buildClient(logService.baseUrl.PRODUCT_LOG_ENTRIES, logService.productLogEntries),
    logs: buildClient(logService.baseUrl.LOGS, logService.logs),
    bulkImport: buildClient(logService.baseUrl.BULK_IMPORT, logService.bulkImport),
    quantities: buildClient(logService.baseUrl.QUANTITIES, logService.quantities),
    scopes: buildClient(logService.baseUrl.SCOPES, logService.scopes),
    subcategories: buildClient(logService.baseUrl.SUBCATEGORIES, logService.subcategories),
    tags: buildClient(logService.baseUrl.TAGS, logService.tags),
    productTags: buildClient(logService.baseUrl.PRODUCT_TAGS, logService.productTags),
    quantityTags: buildClient(logService.baseUrl.QUANTITY_TAGS, logService.quantityTags),
    territories: buildClient(logService.baseUrl.TERRITORIES, logService.territories),
    units: buildClient(logService.baseUrl.UNITS, logService.units),
    userOptions: buildClient(logService.baseUrl.USER_OPTIONS, logService.userOptions),
    closedPeriods: buildClient(logService.baseUrl.CLOSED_PERIODS, logService.closedPeriods),
    emissionFactorChangelogs: buildClient(logService.baseUrl.EMISSION_FACTOR_CHANGELOGS, logService.emissionFactorChangelogs),
    modeledImpacts: buildClient(logService.baseUrl.MODELED_IMPACTS, logService.modeledImpacts),
};
var logApiGatewayClient = {
    categories: buildClient("".concat(logService.baseUrl.SERVICE, "/").concat(logService.baseUrl.CATEGORIES), logService.categories),
    factors: buildClient("".concat(logService.baseUrl.SERVICE, "/").concat(logService.baseUrl.FACTORS), logService.factors),
    factorRequests: buildClient("".concat(logService.baseUrl.SERVICE, "/").concat(logService.baseUrl.FACTOR_REQUESTS), logService.factorRequests),
    importTemplates: buildClient("".concat(logService.baseUrl.SERVICE, "/").concat(logService.baseUrl.IMPORT_TEMPLATES), logService.importTemplates),
    logEntries: buildClient("".concat(logService.baseUrl.SERVICE, "/").concat(logService.baseUrl.LOG_ENTRIES), logService.logEntries),
    productLogEntries: buildClient("".concat(logService.baseUrl.SERVICE, "/").concat(logService.baseUrl.PRODUCT_LOG_ENTRIES), logService.productLogEntries),
    logs: buildClient("".concat(logService.baseUrl.SERVICE, "/").concat(logService.baseUrl.LOGS), logService.logs),
    bulkImport: buildClient("".concat(logService.baseUrl.SERVICE, "/").concat(logService.baseUrl.BULK_IMPORT), logService.bulkImport),
    quantities: buildClient("".concat(logService.baseUrl.SERVICE, "/").concat(logService.baseUrl.QUANTITIES), logService.quantities),
    scopes: buildClient("".concat(logService.baseUrl.SERVICE, "/").concat(logService.baseUrl.SCOPES), logService.scopes),
    subcategories: buildClient("".concat(logService.baseUrl.SERVICE, "/").concat(logService.baseUrl.SUBCATEGORIES), logService.subcategories),
    units: buildClient("".concat(logService.baseUrl.SERVICE, "/").concat(logService.baseUrl.UNITS), logService.units),
    userOptions: buildClient("".concat(logService.baseUrl.SERVICE, "/").concat(logService.baseUrl.USER_OPTIONS), logService.userOptions),
    tags: buildClient("".concat(logService.baseUrl.SERVICE, "/").concat(logService.baseUrl.TAGS), logService.tags),
    productTags: buildClient("".concat(logService.baseUrl.SERVICE, "/").concat(logService.baseUrl.TAGS), logService.productTags),
    quantityTags: buildClient("".concat(logService.baseUrl.SERVICE, "/").concat(logService.baseUrl.QUANTITY_TAGS), logService.quantityTags),
    territories: buildClient("".concat(logService.baseUrl.SERVICE, "/").concat(logService.baseUrl.TERRITORIES), logService.territories),
    calculation_methods: buildClient("".concat(logService.baseUrl.SERVICE, "/").concat(logService.baseUrl.CALCULATION_METHODS), logService.calculation_methods),
    activity_data_sources: buildClient("".concat(logService.baseUrl.SERVICE, "/").concat(logService.baseUrl.ACTIVITY_DATA_SOURCES), logService.activity_data_sources),
    closedPeriods: buildClient("".concat(logService.baseUrl.SERVICE, "/").concat(logService.baseUrl.CLOSED_PERIODS), logService.closedPeriods),
    emissionFactorChangelogs: buildClient("".concat(logService.baseUrl.SERVICE, "/").concat(logService.baseUrl.EMISSION_FACTOR_CHANGELOGS), logService.emissionFactorChangelogs),
    modeledImpacts: buildClient("".concat(logService.baseUrl.SERVICE, "/").concat(logService.baseUrl.MODELED_IMPACTS), logService.modeledImpacts),
    lifecycleSteps: buildClient("".concat(logService.baseUrl.SERVICE, "/").concat(logService.baseUrl.LIFECYCLE_STEPS), logService.lifecycle_steps),
};
export { logService, logServiceClient, logApiGatewayClient };
//# sourceMappingURL=log-service.js.map